/**
 * 头像上传约束（架构 §8 共享知识）
 *  - AVATAR_MAX_PX：最长边上限（canvas 压缩目标）。
 *  - AVATAR_MAX_BYTES：dataURL 字符串体积上限（压缩兜底阈值）。
 */
export const AVATAR_MAX_PX = 256;
export const AVATAR_MAX_BYTES = 80 * 1024; // 81920
